import { errorHandleAction } from 'components/error-handle/actions';
import { put, select } from 'redux-saga/effects';
import i18next from 'i18next';
import { collectionSelector } from 'common/selectors/collection';
import { markVideoFeaturedApi } from 'common/api/videos';
import { collectionIsLoadingAction } from 'common/actions';
import { collectionSetInStoreAction } from 'common/actions/collection';
import { fetchChannelsApi, fetchCollectionApi } from 'common/api';
import { channelsSuccessAction } from 'common/actions/channels';
import { getVideosPerPageSelector } from 'common/selectors';
import { REDUX_NOTIFICATION_TYPES, reduxNotificationAction } from 'components/redux-notification';

export function* markVideoFeaturedEffect({ payload: { video, pageNumber, sort } }) {
  try {
    const perPage = yield select(getVideosPerPageSelector);
    const collection = yield select(collectionSelector);
    yield markVideoFeaturedApi(collection.channelId, video.id);
    yield put(collectionIsLoadingAction());
    const newCollection = yield fetchCollectionApi({
      channelId: video.currentChannel,
      pageNum: pageNumber,
      perPage,
      sorting: sort,
      featuredFirst: true,
    });
    const channels = yield fetchChannelsApi();

    yield put(collectionSetInStoreAction(newCollection));
    yield put(channelsSuccessAction(channels));

    yield put(
      reduxNotificationAction(
        i18next.t('mark_video_as_featured_notification_success'),
        true,
        5,
        REDUX_NOTIFICATION_TYPES.SUCCESS
      )
    );
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
